export const onBoardingSequenceBuild = [
  {
    id: "onboarding_select_data",
    placement: "left-start",
    target: ".chakra-accordion__item > .chakra-accordion__button > .chakra-menu__menu-button",
    image: "",
    title: "Select data",
    description: `First, upload the dataset you want to analyze by clicking the “+” icon next to the Data tab in the sidebar to add it to your Promptbook.
    
Start by picking the sample dataset “Customer 360 Showcase.” After you select it, the dataset will appear in the sidebar and will be automatically included in each new step.
    `,
  },
  {
    id: "onboarding_explore_the_data",
    placement: "left-start",
    target: ".content_editable-container",
    title: "Explore the data",
    description: `We recommend starting with general exploration and gradually narrowing down to more specific data questions. Let’s begin by typing this question:

Generate 3 most insightful visualizations based on this data.`,
  },
  {
    id: "onboarding_send_the_question",
    placement: "left-start",
    target: ".ps_editor__results_run_button",
    title: "Run your query",
    description: `Click the “play” button to watch the AI carry out your request, step by step.`,
  },
  {
    id: "onboarding_explore_the_results",
    placement: "auto",
    target: ".onboarding__table_result_component",
    title: "Explore the results",
    description: `Hover over the chart to reveal its tools—you can enlarge the view, download it as an image, or open the underlying table.`,
  },
  {
    id: "onboarding_continue_exploring",
    placement: "left-start",
    target: ".ps_editor__add_instruction",
    title: "Continue exploring",
    description: `Now, add a new step to pose another question—the selected data will automatically carry over to every subsequent step.`,
  },
  {
    id: "onboarding_ask_new_question",
    placement: "left-start",
    target: ".content_editable-container",
    title: "Add new question",
    description: `Type your question.

New steps don’t remember past results, so make sure your question doesn’t rely on earlier answers.

Not keeping memory of past steps increases the reliability of results significantly.`,
  },
  {
    id: "onboarding_send_the_new_question",
    placement: "left-start",
    target: ".ps_editor__results_run_button",
    title: "Run your new query",
    description: `Click the “play” button to submit your next question and see what insights the AI generates.`,
  },
  {
    id: "onboarding_recipe_finish",
    placement: "left-start",
    title: "🎉 Congratulations!",
    actionLabel: "Finish",
    description: `Woohoo! You just created your first Promptbook!

For more learning resources about best practices in Prompt Studio visit our documentation.`,
  },
];

// const onBoardingSequencePreview = [
//   {
//     id: "onboarding_recipe_start",
//     placement: "right-start",
//     target: ".placeholder-container",
//     title: "Start your script 2",
//     description: "Type your first prompt here and run the instruction. Press “/” to upload a file.",
//   },
// ];
//
// const onBoardingSequenceAPI = [
//   {
//     id: "onboarding_recipe_start",
//     placement: "right-start",
//     target: ".placeholder-container",
//     title: "Start your script 3",
//     description: "Type your first prompt here and run the instruction. Press “/” to upload a file.",
//   },
// ];

export const sequences = {
  build: {
    title: "Add and query data",
    duration: "2min",
    steps: onBoardingSequenceBuild,
  },
  // preview: {
  //   title: "2. Test and share your script",
  //   plan: "Free plan",
  //   duration: "2min",
  //   steps: onBoardingSequencePreview,
  // },
  // api: {
  //   title: "3. Publish your script",
  //   plan: "Starter plan",
  //   duration: "2min",
  //   steps: onBoardingSequenceAPI,
  // },
};
